import { c as _c } from "react/compiler-runtime";
import type { FC, MouseEvent } from 'react';
import { useViewport } from '@sbt-web/hooks';
import { CategoryID } from '@sbt-web/network/types';
import { Button } from '@sbt-web/ui';
import type { FiltersConfigState } from '@/reducers/filtersConfig';
import type { SearchState } from '@/reducers/search';
import { useSavedSearches } from '@/shared/helpers/SavedSearches';
import BellOff from './BellOff';
type Props = {
  search: SearchState;
  filtersConfig: FiltersConfigState;
};
const SavedSearchButton: FC<Props> = props => {
  const $ = _c(10);
  const {
    isMobile
  } = useViewport();
  const {
    search,
    filtersConfig
  } = props;
  const savedSearchesProvider = useSavedSearches();
  let t0;
  if ($[0] !== filtersConfig || $[1] !== savedSearchesProvider || $[2] !== search) {
    t0 = e => {
      e.preventDefault();
      savedSearchesProvider.saveSearch(search, filtersConfig);
    };
    $[0] = filtersConfig;
    $[1] = savedSearchesProvider;
    $[2] = search;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleSave = t0;
  const buttonIsVisible = !(search.category.id === CategoryID.Tutte && search.geo.region.id === "0" && (search.query?.length ?? 0) === 0);
  let t1;
  if ($[4] !== buttonIsVisible || $[5] !== handleSave || $[6] !== isMobile) {
    t1 = buttonIsVisible ? <Button design="text" size={isMobile ? "small" : "medium"} onClick={handleSave} icon={<BellOff isMobile={isMobile} />}>Salva ricerca</Button> : null;
    $[4] = buttonIsVisible;
    $[5] = handleSave;
    $[6] = isMobile;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <div id="saved-search-button">{t1}</div>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default SavedSearchButton;